// Shown before a Partner bulk-signs a selection that includes clients the Manager hasn't signed off yet
// (a Partner sign-off then also signs the Manager's). Continue goes ahead as normal; Cancel abandons the
// bulk sign-off and leaves the selection as it was. Shared by Client Data and Billing Review, which pass
// their own button classes.
import React from 'react';
import Modal from './Modal';

export default function ManagerUnsignedWarningModal({ unsigned, total, cancelClass, continueClass, onCancel, onContinue }) {
  const plural = (n, one, many) => (n === 1 ? one : many);
  return (
    <Modal
      open
      onClose={onCancel}
      title="Manager hasn't signed off on some clients"
      footer={
        <>
          <button type="button" className={cancelClass} onClick={onCancel}>Cancel bulk approval</button>
          <button type="button" className={continueClass} onClick={onContinue}>Continue</button>
        </>
      }
    >
      <p style={{ margin: '0 0 12px' }}>
        <strong>{unsigned}</strong> of the <strong>{total}</strong> selected client{plural(total, '', 's')}{' '}
        {plural(unsigned, "hasn't", "haven't")} been signed off by the Manager yet.
      </p>
      <p style={{ margin: 0 }}>
        If you continue, your sign-off is also recorded as the Manager's for {plural(unsigned, 'that client', 'those clients')}.
        Cancel to leave the selection as it is.
      </p>
    </Modal>
  );
}
